<template>
  <ContentPage nobody>
    <template #header>
      <div class="wiz-expl px-4 pt-2 pb-6">
        <div class="font-weight-bold" style="font-size: 20px;">
          To get you the work you want, we need to collect some information from you.
        </div>

        <div>
          You are in control of every lead you claim, the services you perform, 
          and where you'll work.
        </div>

        <div>
          <ul class="explain-list pl-3">
            <li>
              <div>We need to know how to contact you.</div>
              <div>
                Set your User ID.  This is how you login AND how we contact you 
                when new work is available.
              </div>
            </li>

            <li>
              <div>What kind of work do you want?</div>
              <div>
                These are the kinds of leads we will send you.  You can change these settings at any time.
              </div>
            </li>

            <li>
              <div>How far do you want to travel (default is 50 miles)?</div>
              <div>
                Pro Tip:  You can use any address to set the center of your coverage area.
              </div>
            </li>
          </ul>
        </div>

        <div class="font-italic" style="font-size: 14px">
          All of our leads come from <strong>real homeowners</strong> that have 
          <strong>asked a business</strong> for help.  Even after your trial, you will
          never be charged for a lead you do not claim.
        </div>
      </div>
    </template>

    <div style="font-size: 10px;"/>

    <template #footer>
      <div class="d-flex justify-center py-2 rounded-lg white">
        <v-btn @click="backClick">Back</v-btn>
        <v-btn color="primary" class="ml-4" @click="nextClick">Next</v-btn>
      </div>
    </template>
  </ContentPage>
</template>

<script>
import { ContentPage } from '@/components/pages'

export default {
  name: 'WizardStepB',

  components: { ContentPage },

  data: () => ({}),

  methods: {
    backClick() {
      this.$router.replace( { name: 'wizard' } )
    },

    nextClick() {
      this.$router.replace( { name: 'wizardC' } )
    },
  },
}
</script>

<style scoped>
  .wiz-expl {
    background-color: white;
  }
  div.wiz-expl > div {
    font-size: 16px;
    line-height: 1.2;
    margin-top: 16px;
  }

  li {
    margin-top: 12px;
    position: relative;  /* Essential for positioning ::before relative to the li */
    list-style: none;    /* Remove default list markers */
    padding-left: 24px;  /* Create space for the custom marker */
  }

  li::before {
    color: #64B450; /* Change marker color */
    content: "\F0765"; /* Example: mdi-circle */
    font-family: "Material Design Icons";
    position: absolute;
    left: 0;
    top: 0; /* Adjust this value to vertically align the marker with the text */
  }

  li > :first-child {
    font-weight: bold;
  }
  li > :not(:first-child) {
    margin-top: 4px;
    font-size: 15px;
    color: grey;
  }
</style>
